import { render, staticRenderFns } from "./sbxxglDetail.vue?vue&type=template&id=2d13dd53&scoped=true&"
import script from "./sbxxglDetail.vue?vue&type=script&lang=js&"
export * from "./sbxxglDetail.vue?vue&type=script&lang=js&"
import style0 from "./sbxxglDetail.vue?vue&type=style&index=0&id=2d13dd53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d13dd53",
  null
  
)

export default component.exports